/**
 * Created by Ewald Stamp (ewald.stamp@netmills.de) on 20.02.15.
 */

angular
  .module('farmnet.partner.externalAccounts')
  .factory('ExternalAccountLocale', [
    'Locale',
    function ExternalAccountLocaleFactory(Locale) {
      'use strict';

      var base = 'fe.partner.externalAccounts.{0}.{1}';
      var defaultKey = 'default';

      function ExternalAccountLocale(accountKey) {
        function getKey(localeKey, useDefault) {
          useDefault = useDefault || false;

          var totalKey = base.format(accountKey, localeKey);

          if (useDefault && !Locale.has(totalKey)) {
            var fallbackKey = base.format(defaultKey, localeKey);
            return Locale.get(fallbackKey);
          } else {
            return Locale.get(totalKey);
          }
        }

        this.registrationTitle = getKey('registration.title');
        this.logoUrl = getKey('logo');
        this.username = getKey('username', true);
        this.password = getKey('password', true);
        this.repeatPassword = getKey('repeatPassword', true);
        this.delete = getKey('delete', true);
        this.test = getKey('test', true);
        this.save = getKey('save', true);
        this.createNew = getKey('create', true);
        this.passwordMismatchError = getKey('passwordMismatchError', true);
        this.invalidCredentialsError = getKey('invalidCredentialsError', true);
      }

      return ExternalAccountLocale;
    }
  ]);
